import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

const BadRequestPage = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const handleGoBack = () => {
        navigate(-1); // Navigate back to the previous page
    };

    return (
        <div className="container mt-5">
            <h1>{t('badRequestTitle')}</h1>
            <p>{t('badRequestMessage')}</p>
            <button className="btn btn-primary" onClick={handleGoBack}>
                {t('goBack')}
            </button>
        </div>
    );
};

export default BadRequestPage;
